export const appContext = "";

export const dateFormat = "MM-DD-YYYY";
export const timeFormat = "h:mm A";

// İyilik Puanı (charity score) özelliği geçici olarak gizlendi.
// İleride parametrik (açılıp/kapanabilir) yapıya bağlanacak; şimdilik tek noktadan kontrol için bu flag kullanılıyor.
export const isCharityScoreEnabled = false;
